import React, { Component } from 'react';

//create external json
import happyMeter from '../happyMeter.json';

class CalculatedIcon extends Component{
    constructor(props) {
        super(props);
        this.state = {
            iconId:0,
        };
    }

    componentDidMount(){
        let iconId = Math.floor( (this.props.pos) / this.props.sliderRegionHeight ) - 1;

        if(iconId > happyMeter.length-1){
            iconId = happyMeter.length-1;
        }

        this.setState({
            iconId:iconId,
        });
    }

    componentDidUpdate(prevProps) {
        let iconId = Math.floor( (this.props.pos) / this.props.sliderRegionHeight ) - 1;
        //console.log( props.pos / props.sliderRegionHeight + "->" + Math.floor( (props.pos) / props.sliderRegionHeight ) + "-1");
        //console.log( iconId );
        if(iconId > happyMeter.length-1){
            iconId = happyMeter.length-1;
        }
        if (this.props.iconId !== prevProps.iconId) {
            this.setState({
                iconId:iconId
            });
            this.props.iconId(iconId);
        }
    }
    
    render(){
        return(
            <div className="happy-meter-result">
                {happyMeter[this.state.iconId].icon}
                <div style={{color:"#FFF", display:"none"}}>{this.state.iconId}</div>
            </div>
        );
    }
}

class MoveableButton extends Component {

	constructor(props) {
		super(props);

        let width = window.innerWidth;
        let height = window.innerHeight;
        let size = 10;
        let sliderHeight = 300;
        let sliderTolerance = 30;

        
        
		this.state = {
			move:{
				posx:0,
				posy:0,
				directiony:"",
				directionx:"",
				difference:0
			},
			moveablePlus:{
				size:size,
				margin:15,	
			},
			
			myStartPosPageY:0,			
			
			myPosPageY:0,
			myPosLocationY:0,

			touchMoveTotal:0,

			touched:false,
			movedPos: (sliderHeight/2) - (size/2),
			activediv:true,
			windowHeight:height,
            windowWidth:width,
            
            sliderMaxHeight:sliderHeight,
            sliderWidth:50,
            sliderMinPos: sliderTolerance,
            sliderMaxPos: sliderHeight - sliderTolerance,
            sliderRange: sliderHeight-(sliderTolerance*2),
            sliderRegionHeight: (sliderHeight-(sliderTolerance*2)) / (happyMeter.length),
		}; 
    }
    
    /*
    componentDidUpdate(prevProps) {
        if (this.props.moodSelected !== prevProps.iconId) {
            this.props.moodSelected(1);
        }
    }
    */

    handleResponderGrant = (evt) =>{ 
        let y = evt.nativeEvent.offsetY;
        if( evt.nativeEvent.type === "touchstart" ){
            y = evt.nativeEvent.srcElement.offsetParent.offsetTop;
        }

        //console.log(evt);
        this.setState({
            mouseDown:true,
            offsetParent:y,
        });
        this.setPos(evt);
    }

	handleResponderRelease = (evt) =>{
		//console.log('touch end');
        this.setState({
            mouseDown:false
        });
	}
    
	move = (evt) => { 
        if( this.state.mouseDown ){
            this.setPos(evt);
        }
    } 
    
    setPos = (evt, quickMove) =>{
        let min = this.state.sliderMinPos
        let max = this.state.sliderMaxPos;

        if(quickMove==="top"){
            //console.log("to top", min);
            this.setState({
                movedPos:min - this.state.moveablePlus.size/2
            });
        }else if(quickMove==="bottom"){
            this.setState({
                movedPos:max - this.state.moveablePlus.size/2
            });
        }else{
            //console.log(evt.nativeEvent);
            let y = evt.nativeEvent.offsetY;
            if( evt.nativeEvent.type === "touchmove" ){
                y = evt.nativeEvent.touches[0].clientY - this.state.offsetParent;
                //console.log("is touchmove", y);
            }else{
                //console.log("is mousemove");
            }

            if( 
                Math.floor(y) <= max &&  
                Math.floor(y) >= min
            ){
                this.setState({
                    movedPos:Math.floor(y) - this.state.moveablePlus.size/2
                });
            }
        }
    }

    render() {
        return (
        <div id="sliderContainer">
            <div 
                className="sliderTopIcon"
                style={{zIndex: this.state.mouseDown ? -2 : 1}}
                onClick={(evt) => this.setPos(evt,"top")}>
                    {happyMeter[0].icon}
            </div>
            <div 
                id="sliderContainerInner"
                onMouseMove={(evt) => this.move(evt)}
                onMouseDown={this.handleResponderGrant}
                onMouseOut={this.handleResponderRelease} 
                onMouseUp={this.handleResponderRelease}
                
                onTouchMove={(evt) => this.move(evt)}
                onTouchStart={this.handleResponderGrant}
                onTouchEnd={this.handleResponderRelease} 
                onTouchCancel={this.handleResponderRelease}

                style={{
                    height:this.state.sliderMaxHeight,
                    width:this.state.sliderWidth,
                    //boxShadow: this.state.mouseDown ? "0px 0px 15px inset #848484eb" : "0px 0px 15px inset #848484eb",
                }}
            >

                <div 
                    id="moveableButton"
                    style={{
                        position:"absolute", 
                        left:0,
                        top:0,
                        transform:"translateY("+this.state.movedPos+"px)",
                        backgroundColor:"#000",
                        width: this.state.sliderWidth-10,
                        height: this.state.moveablePlus.size,
                        borderRadius: this.state.moveablePlus.size/2,
                        zIndex: -3,
                        margin: "0 5px",
                    }}>
                    <div className="happy-meter-tooltip">
                        <span style={{color:"#FFF", padding:4, fontSize:10, display:"none"}}>
                            Start Y: { this.state.movedPos + (this.state.moveablePlus.size / 2) }
                        </span>
                        <div>
                            <CalculatedIcon
                                iconId={(icon)=>this.props.moodSelected(icon)}
                                sliderRegionHeight={this.state.sliderRegionHeight} 
                                pos={this.state.movedPos + (this.state.moveablePlus.size / 2)} />
                        </div>
                    </div>
                </div>
            </div>
            <div    
                className="sliderBottomIcon" 
                style={{zIndex: this.state.mouseDown ? -2 : 1}} 
                onClick={(evt) => this.setPos(evt,"bottom")}>
                    {happyMeter[happyMeter.length-1].icon}
            </div>
        </div>
        ); 
    }
}

export default MoveableButton;